import { TreeItem, Registry } from '@zeainc/zea-engine'

/**
 * Represents a Part within a CAD assembly.
 *
 * @extends TreeItem
 */
class CADPart extends TreeItem {
  /**
   * Creates an instance of CADPart setting up the initial configuration for Material and Color parameters.
   *
   * @param {string} name - The name value.
   */
  constructor(name) {
    super(name)
  }

  /**
   * The clone method constructs a new CADPart, copies its values
   * from this item and returns it.
   *
   * @param {number} flags - The flags param.
   * @return {CADPart} - The return value.
   */
  clone(flags) {
    const cloned = new CADPart()
    cloned.copyFrom(this, flags)
    return cloned
  }

  /**
   * The copyFrom method.
   * @param {CADPart} src - The src param.
   * @param {number} flags - The flags param.
   * @private
   */
  copyFrom(src, flags) {
    super.copyFrom(src, flags)
  }

  // ///////////////////////////
  // Persistence

  /**
   * Initializes CADPart's asset, material, version and layers; adding current `CADPart` Geometry Item toall the layers in reader
   *
   * @param {BinReader} reader - The reader param.
   * @param {object} context - The context param.
   */
  readBinary(reader, context) {
    super.readBinary(reader, context)
  }

  /**
   * The toJSON method encodes this type as a json object for persistences.
   *
   * @param {number} flags - The flags param.
   * @return {object} - The return value.
   */
  toJSON(flags = 0) {
    const j = super.toJSON(flags)
    return j
  }

  /**
   * The fromJSON method decodes a json object for this type.
   *
   * @param {object} j - The j param.
   * @param {number} flags - The flags param.
   */
  fromJSON(j, flags = 0) {
    super.fromJSON(j, flags)
  }
}

Registry.register('CADPart', CADPart)

export { CADPart }
